import { Link } from 'react-router'
import { useOptionalUser } from '#app/utils/user.ts'

interface NavItem {
	name: string
	href: string
}

function getMarketingFooterNav(isLoggedIn: boolean) {
	return {
		popular: [
			{
				name: 'Dumpster Rentals',
				href: '/rentals/category/dumpster-and-waste-rental',
			},
			{ name: 'Tool Rentals', href: '/rentals/category/tool-rental' },
			{
				name: 'Truck & Trailer Rentals',
				href: '/rentals/category/truck-and-trailer-rental',
			},
			{
				name: 'Party & Event Rentals',
				href: '/rentals/category/party-and-event-rental',
			},
		] as NavItem[],
		support: [
			{
				name: 'Submit Rental',
				href: isLoggedIn ? '/manage/listings/new' : '/submit-rental',
			},
			{
				name: 'Submit Business',
				href: isLoggedIn ? '/manage/businesses/new' : '/submit-business',
			},
			{ name: 'Contact', href: '/contact' },
		] as NavItem[],
		quickLinks: [
			{ name: 'Rentals', href: '/rentals' },
			{ name: 'Businesses', href: '/businesses' },
			{ name: 'Categories', href: '/rentals/categories' },
			{
				name: 'Dumpster Calculator',
				href: '/tools/dumpster-size-calculator',
			},
			{
				name: 'Equipment Cost Estimator',
				href: '/tools/equipment-cost-estimator',
			},
		] as NavItem[],
		legal: [
			{ name: 'Terms of service', href: '/tos' },
			{ name: 'Privacy policy', href: '/privacy' },
		] as NavItem[],
		social: [
			{ name: 'Facebook', href: '#', iconName: 'share-2' },
			{ name: 'Instagram', href: '#', iconName: 'camera' },
			{ name: 'X', href: '#', iconName: 'share-2' },
			{ name: 'GitHub', href: '#', iconName: 'github-logo' },
			{ name: 'YouTube', href: '#', iconName: 'video' },
		] as { name: string; href: string; iconName: string }[],
	} as const
}

export function MarketingFooter() {
	const user = useOptionalUser()
	const marketingFooterNav = getMarketingFooterNav(!!user)
	return (
		<footer className="border-t">
			<div className="container mx-auto px-6 pt-16 pb-8 sm:pt-24 lg:px-8 lg:pt-32">
				<div className="xl:grid xl:grid-cols-3 xl:gap-8">
					<div className="space-y-4">
						<div className="flex items-center">
							<Link
								to="/"
								className="flex items-center text-3xl leading-none font-black tracking-tight transition-all duration-300 hover:scale-105"
							>
								<span className="text-red-500">RENT</span>
								DFW
							</Link>
						</div>
						<p className="text-muted-foreground text-sm/6 text-balance">
							Discover and connect with local rental businesses across
							Dallas-Fort Worth.
						</p>
						{/* <div className="flex gap-x-6">
							{marketingFooterNav.social.map((item) => (
								<a
									key={item.name}
									href={item.href}
									className="text-muted-foreground hover:text-foreground"
									aria-label={item.name}
								>
									<Icon name={item.iconName as IconName} size="md" />
								</a>
							))}
						</div> */}
					</div>

					<div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
						<div className="md:grid md:grid-cols-2 md:gap-8">
							<div>
								<h3 className="text-sm/6 font-semibold">Popular</h3>
								<ul className="mt-4 space-y-2">
									{marketingFooterNav.popular.map((item) => (
										<li key={item.name}>
											<a
												href={item.href}
												className="text-muted-foreground hover:text-foreground text-sm/6"
											>
												{item.name}
											</a>
										</li>
									))}
								</ul>
							</div>
							<div className="mt-10 md:mt-0">
								<h3 className="text-sm/6 font-semibold">Quick Links</h3>
								<ul className="mt-4 space-y-2">
									{marketingFooterNav.quickLinks.map((item) => (
										<li key={item.name}>
											<a
												href={item.href}
												className="text-muted-foreground hover:text-foreground text-sm/6"
											>
												{item.name}
											</a>
										</li>
									))}
								</ul>
							</div>
						</div>

						<div className="md:grid md:grid-cols-2 md:gap-8">
							<div>
								<h3 className="text-sm/6 font-semibold">Support</h3>
								<ul className="mt-4 space-y-2">
									{marketingFooterNav.support.map((item) => (
										<li key={item.name}>
											<a
												href={item.href}
												className="text-muted-foreground hover:text-foreground text-sm/6"
											>
												{item.name}
											</a>
										</li>
									))}
								</ul>
							</div>
							<div className="mt-10 md:mt-0">
								<h3 className="text-sm/6 font-semibold">Legal</h3>
								<ul className="mt-4 space-y-2">
									{marketingFooterNav.legal.map((item) => (
										<li key={item.name}>
											<a
												href={item.href}
												className="text-muted-foreground hover:text-foreground text-sm/6"
											>
												{item.name}
											</a>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
				</div>

				<div className="mt-16 border-t pt-8 sm:mt-20 lg:mt-24">
					<p className="text-muted-foreground text-sm/6">
						&copy; {new Date().getFullYear()} RentDFW. All rights reserved.
					</p>
				</div>
			</div>
		</footer>
	)
}
